import React from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  Box,
  Menu,
  MenuItem,
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import { BookmarkBorder, Dashboard, Add, Logout, Login, PersonAdd, CardMembership, People, AccountCircle, Settings, Label, Person } from '@mui/icons-material';
import { useAuth } from '../../context/AuthContext';

const Navbar: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, isAdmin, user, logout } = useAuth();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);

  const isActive = (path: string) => location.pathname === path;

  const handleLogout = () => {
    logout();
    navigate('/login');
  };

  const handleUserMenuOpen = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(event.currentTarget);
  };

  const handleUserMenuClose = () => {
    setAnchorEl(null);
  };

  const handleNavigateAndClose = (path: string) => {
    navigate(path);
    handleUserMenuClose();
  };

  return (
    <AppBar position="static">
      <Toolbar>
        <BookmarkBorder sx={{ mr: 2 }} />
        <Typography variant="h6" component="div" sx={{ flexGrow: 1 }}>
          Useful Sources
        </Typography>

        {isAuthenticated && user && (
          <Typography variant="body2" sx={{ mr: 2, opacity: 0.9 }}>
            Welcome, {user.firstName}!
          </Typography>
        )}

        <Box sx={{ display: 'flex', gap: 1 }}>
          {isAuthenticated ? (
            <>
              <Button
                color="inherit"
                startIcon={<Dashboard />}
                onClick={() => navigate('/dashboard')}
                variant={isActive('/dashboard') ? 'outlined' : 'text'}
              >
                Dashboard
              </Button>

              <Button
                color="inherit"
                startIcon={<BookmarkBorder />}
                onClick={() => navigate('/sources')}
                variant={isActive('/sources') ? 'outlined' : 'text'}
              >
                Sources
              </Button>

              <Button
                color="inherit"
                startIcon={<Add />}
                onClick={() => navigate('/sources/add')}
                variant={isActive('/sources/add') ? 'outlined' : 'text'}
              >
                Add Source
              </Button>

              <Button
                color="inherit"
                startIcon={<Label />}
                onClick={() => navigate('/tags')}
                variant={isActive('/tags') ? 'outlined' : 'text'}
              >
                Tags
              </Button>

              <Button
                color="inherit"
                startIcon={<Person />}
                onClick={() => navigate('/authors')}
                variant={isActive('/authors') ? 'outlined' : 'text'}
              >
                Authors
              </Button>

              {isAdmin && (
                <>
                  <Button
                    color="inherit"
                    startIcon={<CardMembership />}
                    onClick={() => navigate('/invitations')}
                    variant={isActive('/invitations') ? 'outlined' : 'text'}
                  >
                    Invitations
                  </Button>

                  <Button
                    color="inherit"
                    startIcon={<People />}
                    onClick={() => navigate('/users')}
                    variant={isActive('/users') ? 'outlined' : 'text'}
                  >
                    Users
                  </Button>
                </>
              )}

              <Button
                color="inherit"
                startIcon={<AccountCircle />}
                onClick={handleUserMenuOpen}
              >
                Profile
              </Button>

              <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleUserMenuClose}
              >
                <MenuItem onClick={() => handleNavigateAndClose('/profile')}>
                  <AccountCircle sx={{ mr: 1 }} />
                  My Profile
                </MenuItem>
                <MenuItem onClick={() => handleNavigateAndClose('/settings')}>
                  <Settings sx={{ mr: 1 }} />
                  Settings
                </MenuItem>
                <MenuItem divider />
                <MenuItem onClick={() => {
                  handleUserMenuClose();
                  handleLogout();
                }}>
                  <Logout sx={{ mr: 1 }} />
                  Logout
                </MenuItem>
              </Menu>
            </>
          ) : (
            <>
              <Button
                color="inherit"
                startIcon={<Login />}
                onClick={() => navigate('/login')}
              >
                Login
              </Button>
              <Button
                color="inherit"
                startIcon={<PersonAdd />}
                onClick={() => navigate('/register')}
              >
                Register
              </Button>
            </>
          )}
        </Box>
      </Toolbar>
    </AppBar>
  );
};

export default Navbar;